module.exports = __webpack_public_path__ + "static/media/6720.b48fd092.jpg";